import { createFileRoute } from "@tanstack/react-router";
import CreateNewOrderScreen from "../../../Screens/CreateNewOrder";

export const Route = createFileRoute("/order/new/")({
  component: RouteComponent,
});

function RouteComponent() {
  return <CreateNewOrderScreen />;
}
